export default "__VITE_ASSET__DDaTmAZO__"